export default __webpack_public_path__ + "static/media/Highlord's Clasp of Force.42d7fab8.jpg";